import { css } from '@emotion/react';

import { responsiveBreakpoint } from "@constants";

export const scrollWrapper = css`
  height: 100vh;
  overflow-y: auto;
`;

export const centerBox = css`
  @media (min-width: ${responsiveBreakpoint[0]}px) {
    width: 100%;
    max-width: 1092px;
    padding: 0 16px;
    margin: auto;
  }
`;

export const contentBox = css`
  @media (min-width: ${responsiveBreakpoint[0]}px) {
    min-height: 400px;
  }
`;
